import { ErrorHandler, NgModule } from '@angular/core';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { MonitoringService } from './monitoring.service';

@NgModule({
	imports: [ApmModule],
	declarations: [],
	exports: [],
	providers: [
		MonitoringService,
		ApmService,
		{
			provide: ErrorHandler,
			useClass: ApmErrorHandler
		}
	]
})
export class NHAMonitoringModule {}
